<template>
  <div>
    <SystemBar ref="system-bar" />
    <div
      class="d-flex justify-center pa-5"
      style="height: calc(100vh - 31.99px) !important"
    >
      <v-avatar color="green lighten-3">
        <Icon
          :width="24"
          :color="'#43A047'"
          :icon="'video-check-outline'"
        />
      </v-avatar>
      <div class="ml-3">
        <p class="mb-1">
          Tienes la video atención activa en otra pestaña.
        </p>
        <small class="text--secondary">
          De no ser así es posible que con refrescar la página recupere la video atención.
        </small>
      </div>
    </div>
    <Confirm
      ref="confirm"
      title="Salir"
      detail="Se reiniciar completamente el servicio y podrá empezar una nueva atención"
      action="Confirmar"
      @confirmHandler="reset"
    />
  </div>
</template>

<script>
/* eslint-disable */
import { Component, Vue } from 'vue-property-decorator'

@Component({
  components: {
    SystemBar: () => import(/* webpackPrefetch: true */ '@/components/SystemBar.vue'),
    Confirm: () => import(/* webpackPrefetch: true */ '@/components/Confirm.vue'),
    Icon: () => import(/* webpackPrefetch: true */ '@/components/Icon.vue')
  }
})
export default class ActiveCall extends Vue {
  mounted () {
    setTimeout(() => {
      this.$widget.toggle(false)
    }, 5000)
  }

  reset () {
    this.$refs['system-bar'].reset
  }
}
</script>
